<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="10" class="pt-0 pb-0">
                <template>
                    <v-container class="pt-0">
                        <v-row>
                            <v-col cols="12" class="pt-0 pl-0 pr-0">
                                <filter-account></filter-account>
                            </v-col>                            
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0">
                                <div class="content-list-debts wost-scroll">
                                    <card-account></card-account>
                                </div>                                
                            </v-col>                            
                        </v-row>
                    </v-container>
                </template>
            </v-col>
            <v-col cols="2">
                <summary-account></summary-account>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CardAccount from '../../components/Providers/CardAccount'

import FilterAccount from '../../components/Providers/FilterAccount'
import SummaryAccount from '../../components/Providers/SummaryAccount'

export default {
    name: 'ProviderAccount',
    components: {
        CardAccount,
        FilterAccount,
        SummaryAccount
    }
}
</script>

<style scoped>

</style>